import React from "react";
import styled from "styled-components";
import { ReactComponent as DownloadIcon } from "assets/images/download_icon.svg";
import GridSkeletonLoaderComponent from "./GridSkeletonLoaderComponent";
import LineChartSkeletonLoader from "./LineChartSkeletonLoader";
import { ReactComponent as DownArrowIcon } from "assets/images/menu_downarrow.svg";
import i18n from "i18next";
import { keyframes } from "styled-components";
const SkeletonLoaderContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

const DownloadButtonContainer = styled.div`
  margin-top: 12px
  display: flex;
  align-items: center;
  margin-left: auto;
  z-index: 100;
`;
const DownloadButton = styled.div`
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    background-color: ${props => props.theme.focusBackgroundColor};
  }

  &:focus {
    background-color: ${props => props.theme.focusBackgroundColor};
  }
`;

const CSVDownloadIcon = styled(DownloadIcon)`
  pointer-events: none;
  path {
    fill: ${props => props.theme.svgDefaultColor};
  }
`;

const DetailsContainer = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 2px;
`;

const NoLastUpdated = styled.div`
  flex: 1;
`;

const HoldingTabSkeletonLoaderComponent = () => {
  return (
    <SkeletonLoaderContainer>
      <DetailsContainer>
        <DownloadButtonContainer>
          <DownloadButton>
            <CSVDownloadIcon></CSVDownloadIcon>
          </DownloadButton>
        </DownloadButtonContainer>
      </DetailsContainer>
      <GridSkeletonLoaderComponent columnHeaders={["Asset", "Value"]} />
    </SkeletonLoaderContainer>
  );
};
export default HoldingTabSkeletonLoaderComponent;
